<div
  (click)="onLocationClicked(); isReadonly() ? null : $event.stopPropagation()"
  [class.hover-opacity]="!isReadonly()"
  class="flex items-center gap-2 w-full min-w-0"
>
  @if (showIcon()) {
    <mat-icon
      fontIcon="location_on"
      class="icon-muted shrink-0"
    />
  }

  <div class="min-w-0 w-full overflow-hidden">
    <p
      #namePath
      [class.opacity-50]="!locationPresent()"
      [class.lowercase]="!locationPresent()"
      [matTooltip]="fullLocationsNamePath()"
      [class.truncate]="!twoLines()"
      [class.line-clamp-2]="twoLines()"
      [class.wrap-anywhere]="twoLines()"
      class="w-full"
    >
      @if (locationPresent()) {
        {{ location() && visibleLocationsNamePath() }}
      } @else if (small()) {
        —
      } @else {
        {{ 'project-tasks.list.column-headers.location' | translate }}
      }
    </p>
  </div>
</div>
